import { pluck } from 'underscore';

export const getListingGroupDetails = (i18n, isEditing, {
  productFilter,
  listingGroup,
}) => {
  if (isEditing && productFilter) {
    return `${i18n.getString(_TL_('Products: Filterd by '))}${productFilter}`;
  }
  if (!isEditing) {
    if (!listingGroup) {
      return i18n.getString('All products');
    }
    return `${listingGroup.operand}: ${pluck(listingGroup.items, 'primary').join(',')}`;
  }
  return '';
};
